import { Button } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import CarModelField from './CarModelField';
import StaticField from './StaticField';
import { GridBox } from './ui';

interface CalculatorContainerProps {
    config: any; // temporary type
    dataSource: any;
}

const Container = styled.div`
    max-width: 450px;
    margin: 0px auto;
    padding-bottom: 30px;
`;

const CarImage = styled.img`
    width: 100%;
    max-width: 450px;
    margin: 10px 0px;
`;

const Next = styled.div`
    display: flex;
    margin-top: 20px;
    margin-left: -5px;
    margin-right: -5px;
`;

const CalculatorContainer = (props: CalculatorContainerProps) => {
    const { config, dataSource } = props;
    const { t } = useTranslation(['calculation']);

    const calculatorFields = useMemo(
        () =>
            config.map(obj => (
                <StaticField label={t(`calculation:labels.${obj.key}`)} value={dataSource[obj.key]} {...obj} />
            )),
        [config, dataSource, t]
    );

    return (
        <Container>
            <CarImage alt="icon" src={dataSource.imgSrc} />
            <GridBox size={2}>
                <CarModelField
                    carModel={dataSource.carModel}
                    count={dataSource.inStock}
                    price={dataSource.startingPrice}
                />
                {calculatorFields}
            </GridBox>
            <Next>
                <Button size="large" type="primary" block>
                    {t('calculation:actions.next')}
                </Button>
            </Next>
        </Container>
    );
};

export default CalculatorContainer;
